import { render, staticRenderFns } from "./automobileTwo.vue?vue&type=template&id=29d58675&scoped=true"
import script from "./automobileTwo.vue?vue&type=script&lang=js"
export * from "./automobileTwo.vue?vue&type=script&lang=js"
import style0 from "./automobileTwo.vue?vue&type=style&index=0&id=29d58675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d58675",
  null
  
)

export default component.exports